import apiSportsFederations from '@/api/sports-federations'

const state = {
  isLoading: false,
  sportsFederations: [],
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  getSportFederationsStart: '[sportsFederations] getSportFederationsStart',
  getSportFederationsSuccess: '[sportsFederations] getSportFederationsSuccess',
  getSportFederationsFailure: '[sportsFederations] getSportFederationsFailure',

  addSportFederationsStart: '[sportsFederations] addSportFederationsStart',
  addSportFederationsSuccess: '[sportsFederations] addSportFederationsSuccess',
  addSportFederationsFailure: '[sportsFederations] addSportFederationsFailure'
}

export const actionType = {
  getSportFederations: '[sportsFederations] getSportFederations',
  addSportFederations: '[sportsFederations] addSportFederations'
}

const mutations = {
  [mutationTypes.getSportFederationsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportFederationsSuccess](state, payload) {
    state.isLoading = false
    state.sportsFederations = payload.map(federation => ({
      type: 'federation',
      ...federation
    }))
  },

  [mutationTypes.getSportFederationsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addSportFederationsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addSportFederationsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.getSportFederationsFailure](state) {
    state.isSubmitting = false
  }
}

const actions = {
  [actionType.getSportFederations](context) {
    context.commit(mutationTypes.getSportFederationsStart)
    return new Promise(resolve => {
      apiSportsFederations
        .getSportFederations()
        .then(response => {
          context.commit(
            mutationTypes.getSportFederationsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getSportFederationsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.addSportFederations](context, sport) {
    context.commit(mutationTypes.addSportFederationsStart)
    return new Promise(resolve => {
      apiSportsFederations
        .addSportFederations(sport)
        .then(response => {
          context.commit(
            mutationTypes.addSportFederationsSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.addSportFederationsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
